import { DateTime } from 'luxon';
import { capitalize } from 'vue';

import { DASH } from '@/globals';
import Validatable from '@/validator/Validatable';
import i18n from '@/vueI18n';

export interface IUser {
  id: number;
  email: string;
  isActivated: boolean;
  isActive: boolean;
  isGlobalAdmin: boolean;
  lastLoginUtc: string;
  createdOnUtc: string;
  modifiedOnUtc: string;
  profilePictureUrl: string;
}

export interface IUserApi {
  user_id: number;
  email: string;
  is_activated: boolean;
  is_active: boolean;
  global_admin: boolean;
  last_login_utc?: string;
  created_on_utc?: string;
  modified_on_utc?: string;
  profile_picture_url: string;
}

export default class User extends Validatable {
  email: string;

  isActivated: boolean;

  isActive: boolean;

  isGlobalAdmin: boolean;

  lastLoginUtc: string;

  createdOnUtc: string;

  modifiedOnUtc: string;

  profilePictureUrl: string;

  constructor(
    id = -1,
    email: string = '',
    isActivated: boolean = true,
    isActive: boolean = true,
    isGlobalAdmin: boolean = false,
    lastLoginUtc = null,
    createdOnUtc = null,
    modifiedOnUtc = null,
    profilePictureUrl = null,
  ) {
    super();
    this.id = id;
    this.email = email;
    this.isActivated = isActivated;
    this.isActive = isActive;
    this.isGlobalAdmin = isGlobalAdmin;
    this.lastLoginUtc = lastLoginUtc;
    this.createdOnUtc = createdOnUtc;
    this.modifiedOnUtc = modifiedOnUtc;
    this.profilePictureUrl = profilePictureUrl;
  }

  static fromApi(apiObject: IUserApi): User {
    return new User(
      apiObject.user_id,
      apiObject.email,
      apiObject.is_activated,
      apiObject.is_active,
      apiObject.global_admin,
      apiObject.last_login_utc,
      apiObject.created_on_utc,
      apiObject.modified_on_utc,
      apiObject.profile_picture_url,
    );
  }

  toApi(): IUserApi {
    return {
      user_id: this.id,
      email: this.email,
      is_activated: this.isActivated,
      is_active: this.isActive,
      global_admin: this.isGlobalAdmin,
      profile_picture_url: this.profilePictureUrl,
    };
  }

  static fromObject(obj: IUser): User {
    return super.fromObject(obj, new User());
  }

  get isActiveDescription(): string {
    const key = this.isActive ? 'yes' : 'no';
    return capitalize(i18n.global.t(`actions.${key}`));
  }

  get isActivatedDescription(): string {
    const key = this.isActivated ? 'yes' : 'no';
    return capitalize(i18n.global.t(`actions.${key}`));
  }

  get lastLoginFormatted(): string {
    return this.lastLoginUtc != null
      ? DateTime.fromISO(this.lastLoginUtc, { zone: 'utc' }).toLocal().toLocaleString(DateTime.DATETIME_MED)
      : DASH;
  }
}
